<template>
  <div class="change--wrapper" v-loading="loading">
    <el-row :gutter="16">
      <el-col :lg="10" :md="24" :xl="10">
        <el-card :style="`height: 286px`" class="card--box content-card-box">
          <div class="header--title" slot="header">{{ $t('stores::products-info::base_attr') }}</div>
          <el-form :model="detailForm" label-position="left" label-width="100px" ref="basicForm" style="padding: 16px">
            <el-form-item label="SPU：">{{ detailForm.id }}</el-form-item>
            <el-form-item :label="$t('stores::products-info::name') + '：'">
              {{ detailForm.title }}
            </el-form-item>
            <el-form-item :label="$t('system::responsible::供应商') + '：'">
              <div style="display: flex">
                {{ detailForm.supplier }}
              </div>
            </el-form-item>
            <el-form-item :label="$t('stores::products-info::category') + '：'">
              <div style="display: flex">
                {{ detailForm.categoryNames }}
              </div>
            </el-form-item>
            <el-form-item :label="$t('stores::products-info::currency') + '：'">
              {{ detailForm.spuCurrency }}
            </el-form-item>
          </el-form>
        </el-card>
      </el-col>
      <el-col :lg="14" :md="24" :xl="14">
        <el-card :title="$t('stores::products-info::goods_detail')" class="card--box">
          <div class="header--title" slot="header">{{ $t('stores::products-info::goods_detail') }}</div>
          <div v-if="detailForm.spuLongDesc">
            <!-- <rich-editor
              :height="222"
              :placeholder="$t('stores::products-info::input_goods_detail')"
              v-model="detailForm.spuLongDesc"
            ></rich-editor> -->
            <div v-html="detailForm.spuLongDesc" style="height: 198px; overflow: auto"></div>
          </div>
          <default-data v-else style="height: 198px"></default-data>
        </el-card>
      </el-col>
    </el-row>
    <el-row>
      <el-card class="card--box img-content-wrapper content-card-box">
        <div class="header--title" slot="header">商品信息</div>
        <div style="margin-bottom: 10px">商品图片</div>
        <div class="image-list">
          <ZImg v-for="(item, index) in detailForm.spuImages" :key="index" :src="item" class="images"></ZImg>
        </div>
        <z-table
          :data="detailForm.skus"
          :max-height="300"
          :pagination="false"
          :columns="skuTableColumns"
          ref="skuTable"
          style="margin-top: 24px"
        >
          <template #imageUrl="{ row }">
            <ZImg :src="row.imageUrl" style="width: 60px; height: 60px"></ZImg>
          </template>
          <template #weight="{ row }">{{ $dataCheck(row.weight) }}{{ row.weightUnit }}</template>
          <template #purchasePrice="{ row }">{{ $dataCheck(row.purchasePrice) }}</template>
          <template #compareAtPrice="{ row }">{{ $dataCheck(row.compareAtPrice) }}</template>
          <template #salePrice="{ row }">{{ $dataCheck(row.salePrice) }}</template>
          <template #safeInventory="{ row }">{{ $dataCheck(row.safeInventory) }}</template>
          <template #skuInventory="{ row }">{{ $dataCheck(row.skuInventory) }}</template>
          <template v-for="(val, index) in selectedSkuOpt" #[val.label]="{ row }">
            <div :key="index">
              {{ row.options[index].value }}
            </div>
          </template>
          <template #options="{ row }">
            <div style="display: flex">
              <div class="option-list" v-for="(item, index) in row.options" :key="index">
                <div>{{ item.name }}</div>
                <div>{{ $dataCheck(item.value) }}</div>
              </div>
            </div>
          </template>
        </z-table>
      </el-card>
    </el-row>
  </div>
</template>

<script>
import EditDialog from '@/views/supplier/components/editDialog'
import EditAttrDialog from '@/views/commodity-center/prop/components/editDialog'
import cateModal from '@/views/commodity-center/category/category-modal'
import RichEditor from '@/components/rich-editor'
import * as Api from '@/server/product'
import skuTable from '../components/sku-table'
import skuModal from '../components/sku-modal'
import skuMultiple from '../components/sku-multiple'
import { createHash } from '@/utils'
import pictureCard from '@/components/common/picture-list'
import ImgUpload from '@/views/commodity-center/products/product-info/components/ImgUpload'
import { tableColumns } from '../addOrEdit/config'

export default {
  name: 'index',
  components: {
    EditAttrDialog,
    skuTable,
    cateModal,
    RichEditor,
    ImgUpload,
    pictureCard,
    EditDialog,
    skuModal,
    skuMultiple,
  },
  data() {
    return {
      isAttrEdit: false,
      loading: false,
      moreEdit: false,
      hoverImgList: [],
      skuSelections: [],
      cateInfoData: null,
      detailForm: {
        spu_code: '',
        title: '',
        supplier: '',
        supplierId: '',
        categoryId: [],
        spuSizeDesc: '',
        spuLongDesc: '',
        spuCurrency: 'USD',
        skus: [],
        spuImages: [],
        spuOptions: [],
      },
      showSetAttributes: false,
      isAdd: true,
      categoryOpt: [],
      supplierList: [],
      attrList: [],
      selectedAttrList: [],
      attrSearchVal: '',
      selectedSkuOpt: [],
      saveLoading: false,
      showAddSupplier: false,
      tableColumns: [
        {
          label: 'SKU',
          prop: 'id',
          minWidth: 120,
        },
        {
          label: this.$t('stores::products-info::图片'),
          prop: 'imageUrl',
          minWidth: 120,
        },
        {
          label: this.$t('stores::products-info::purchase_price'),
          prop: 'purchasePrice',
          minWidth: 120,
        },
        {
          label: this.$t('stores::products-info::compare_at_price'),
          prop: 'compareAtPrice',
          minWidth: 120,
        },
        {
          label: this.$t('stores::products-info::sale_price'),
          prop: 'salePrice',
          minWidth: 120,
        },
        {
          label: this.$t('stores::products-info::safe_stock'),
          prop: 'safeInventory',
          minWidth: 120,
        },
        {
          label: this.$t('stores::products-info::goods_stock'),
          prop: 'skuInventory',
          minWidth: 120,
        },
        {
          label: this.$t('stores::products-info::weight'),
          prop: 'weight',
          minWidth: 120,
        },
      ],
      backRow: {
        type: 'edit',
        item: {},
        index: undefined,
      },
      visable: false,
      multipleDialog: false,
    }
  },
  computed: {
    skuTableColumns() {
      return [...this.tableColumns, ...this.selectedSkuOpt]
    },
  },
  watch: {
    skuTableColumns: {
      handler() {
        this.$nextTick(() => {
          this.$refs.skuTable && this.$refs.skuTable.$refs.elTable && this.$refs.skuTable.$refs.elTable.doLayout()
        })
        this.$forceUpdate()
      },
      deep: true,
      immediate: true,
    },
    $route: {
      handler: function (to) {
        if (to.params && to.params.id && to.params.id != this.detailForm.id) {
          this.getDetail()
        }
      },
      immediate: true,
    },
  },
  methods: {
    back() {
      this.$router.back()
    },
    async getDetail() {
      // 判断复制的情况
      this.detailForm = {
        spu_code: '',
        title: '',
        supplier: '',
        supplierId: '',
        categoryId: [],
        spuSizeDesc: '',
        spuLongDesc: '',
        spuCurrency: 'USD',
        skus: [],
        spuImages: [],
        spuOptions: [],
      }
      const urlParams = this.$route.params.id.split('+')
      this.loading = true
      const res = await Api.getProduct(urlParams[0])
      this.loading = false
      if (res.data.code === this.$code) {
        this.detailForm = res.data.data
        if (res.data.data.skus[0].options) {
          this.selectedSkuOpt = res.data.data.skus[0].options.map(item => {
            const obj = this.attrList.find(attr => attr.name === item.name)
            return {
              label: item.name,
              list: item.list || (obj && obj.list) || [],
              prop: item.name,
              value: '',
              name: item.name,
              width: 100,
            }
          })
          this.detailForm.skus = JSON.parse(
            JSON.stringify(
              this.detailForm.skus.map(item => {
                if (item.options && item.options.length) {
                  item.options = item.options.map(item => {
                    const obj = this.attrList.find(attr => attr.name === item.name)
                    item.list = (obj && obj.list) || []
                    return {
                      ...item,
                    }
                  })
                }
                return {
                  ...item,
                }
              })
            )
          )
        } else {
          res.data.data.skus.forEach(item => {
            item.options = []
          })
        }
      }
    },
  },
}
</script>

<style scoped lang="scss">
.btn-wrapper {
  height: 28px;
}
.input-search-box {
  position: relative;
  display: flex;
  padding-right: 12px;
  .add-btn {
    font-size: 14px;
    cursor: pointer;
    flex: 0 0 auto;
    margin-left: 8px;
    color: #010517;
    background: #f0f0f0;
    line-height: 40px;
    display: inline-block;
    text-align: center;
    height: 40px;
    width: 40px;
    border-radius: 5px;
    top: 0;
  }
}
/deep/ .el-card .el-card__header {
  border-bottom: 1px solid #dcdfe6;
}
.setting-attr-btn {
  float: right;
  width: 28px;
  height: 28px;
  padding: 0;
  font-size: 16px;
}
.change--wrapper {
  padding-bottom: 45px;
}
::v-deep {
  .manage-dialog-modal {
    .col-manage-item {
      min-height: 300px;
      box-sizing: border-box;
    }
  }
}
.info-content-wrapper {
  height: 706px;
  display: flex;
  flex-direction: column;
  ::v-deep {
    .content-card-box {
      .el-card__body {
        padding: 0 16px;
      }
    }
  }

  .img-content-wrapper {
    height: 336px;
  }
}
.fixed-sku-wrapper {
  margin-bottom: 16px;
  height: 686px;

  .card--box {
    height: 100%;
  }
}
.input-item {
  // width: 200px;
  flex: 1;
}
.card--box {
  margin: 10px 0;
}

.iconadd {
  margin-left: 5px;
}
.header--title {
  font-size: 16px;
  font-weight: 500;
  color: #010517;
  line-height: 40px;
}

.prodinfo--edit__picAdd {
  .title {
    font-size: 14px !important;
  }
}
.prodinfo--edit {
  &__table {
    ::v-deep {
      .el-input {
        width: 80px;
      }
    }
    ///deep/ .el-input-number {
    //  width: 60px;
    //  display: inline-block;
    //}
  }
  &__tableImgAdd {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
  &__tablePicAdd {
    cursor: pointer;
    box-sizing: border-box;
    width: 40px;
    height: 40px;
    display: inline-block;
    line-height: 36px;
    text-align: center;
    font-size: 24px;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
  }
  &__picAdd {
    width: 80px;
    height: 80px;
    margin-right: 8px;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    cursor: pointer;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    color: #3a416f;
    font-size: 40px;
    .title {
      font-size: 20px;
    }
  }
  &__attrList {
    display: inline-block;
    padding: 10px;
    width: 186px;
    max-height: 350px;
    overflow: auto;
    li {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 5px 0;
    }
  }
  &__imgBox {
    display: inline-block;
    width: 80px;
    height: 80px;
    overflow: hidden;
    margin-right: 6px;
    position: relative;
    img {
      width: 100%;
      height: 100%;
    }
  }
  &__wrapper {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background-color: rgba(255, 255, 255, 0.6);
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 30px;
  }
}
.add-btn {
  font-size: 14px;
  cursor: pointer;
  flex: 0 0 auto;
  margin-left: 8px;
  color: #010517;
  background: #f0f0f0;
  line-height: 40px;
  display: inline-block;
  text-align: center;
  height: 40px;
  width: 40px;
  border-radius: 5px;
  top: 0;
}
.option-list {
  border: 1px solid #dddddd;
  border-radius: 4px;
  display: flex;
  height: 38px;
  div {
    padding: 13px;
  }
  div + div {
    border-left: 1px solid #dddddd;
  }
}
.option-list + .option-list {
  margin-left: 17px;
}
.image-list {
  display: flex;
  flex-wrap: wrap;
  .images {
    width: 65px;
    height: 65px;
  }
  .images + .images {
    margin-left: 16px;
  }
}
/deep/.el-form-item {
  margin-bottom: 0;
}
/deep/.el-form-item + .el-form-item {
  margin-top: 24px;
}
/deep/.el-form-item__label {
  line-height: 1;
}
/deep/.el-form-item__content {
  line-height: 1;
}
</style>
